
/* US sitewide rollout of the accepted native Ymq options, 2026-11-02. */
(() => {
  'use strict';
  if (!location.pathname.includes('/products/')) return;
  const native = window.ymq_option;
  if (!native?.ymq_template_options) { console.error('Customisation pilot: native Ymq configuration is not available.'); return; }
  let changed = 0;
  for (const bundle of [...Object.values(native.ymq_template_options), {template:native.ymq_option_data,condition:native.ymq_option_condition}]) {
    const fields = Object.values(bundle.template || {});
    const byId = new Map(fields.map(f => [f.id, f]));
    const offers = new Map(fields.filter(f => /offer.*details.*via/i.test(f.label)).map(f => [f.id, f]));
    for (const [id, rule] of Object.entries(bundle.condition || {})) {
      const target = byId.get(id);
      if (!target || Number(rule.type) !== 1) continue;
      // Main reference photos still follow the customer's upload/email choice.
      if (Number(target.type) === 12 && !/cloth|outfit/i.test(target.label)) continue;
      for (const predicate of Object.values(rule.options || {})) {
        const offer = offers.get(predicate.id);
        if (!offer || Number(predicate.type) !== 1) continue;
        const selected = Object.values(offer.options || {}).find(o => o.id === predicate.value);
        if (!selected) continue;
        // Evaluate subsequent detail gates as Upload Now in either chosen mode.
        // Native "not empty" and "empty" conditions preserve dependent child rules.
        if (/upload/i.test(selected.value)) { predicate.type = '12'; predicate.value = ''; changed++; }
        else if (/email/i.test(selected.value)) { predicate.type = '11'; predicate.value = ''; changed++; }
      }
    }
  }
  // Keep the tested feature version used by the controller and its CSS.
  document.documentElement.dataset.cbOptionsPilot = '20261101';
  document.documentElement.dataset.cbOptionsRollout = '20261102';
  document.documentElement.dataset.cbPilotConditionUpdates = String(changed);
})();

/* Native Ymq purchase flow, 2026-11-03. No item, price or checkout payload is constructed here. */
(() => {
  'use strict';
  const DEFAULT_ENABLED = true;
  const control = new URL(location.href).searchParams.get('bf_purchase_fast');
  if (control === '0' || (!DEFAULT_ENABLED && control !== '1')) return;
  const productPage = /\/products\//.test(location.pathname);
  const cartPage = /\/cart\/?$/.test(location.pathname);
  if ((!productPage && !cartPage) || window.bfPurchaseFastInstalled) return;
  window.bfPurchaseFastInstalled = true;
  document.documentElement.dataset.bfPurchaseFast = '20261103';

  const native = window.ymq_option;
  const extra = native?.ymq_option_branding?.extra;
  if (productPage && extra) {
    // Let the app load and render its own cart, including its own price and option handling.
    if (Object.prototype.hasOwnProperty.call(extra, 'options_list_show')) {
      extra.options_list_show_old = extra.options_list_show;
    }
    extra['ajaxcart-modal'] = 2;
    const trigger = '.bf-compact-header__cart';
    const existing = String(extra['trigger-ajaxcart-modal-show'] || '').split(',').map(s => s.trim()).filter(Boolean);
    if (!existing.includes(trigger)) existing.push(trigger);
    extra['trigger-ajaxcart-modal-show'] = existing.join(',');
    if (native.ymq_option_branding.lan) native.ymq_option_branding.lan.checket = 'Proceed to checkout';
  }

  const service = new URL(window.ymq_option_prefix_url || 'https://option-v1.ymq.cool/shop/').origin;
  if (service.startsWith('https://') && /(^|\.)ymq\.cool$/.test(new URL(service).hostname) &&
      !document.querySelector(`link[rel="preconnect"][href="${service}"]`)) {
    const link = document.createElement('link');
    link.rel = 'preconnect'; link.href = service; link.crossOrigin = 'anonymous'; document.head.append(link);
  }

  // Refresh the connection when purchase intent is visible; no checkout or cart request is sent.
  // A query override remains available for a controlled comparison or per-session fallback.
  const WARM_DEFAULT_ENABLED = true;
  const warmControl = new URL(location.href).searchParams.get('bf_checkout_warm');
  const warmEnabled = warmControl !== '0' && (WARM_DEFAULT_ENABLED || warmControl === '1');
  const warmModes = ['anonymous'];
  let warmedAt = -Infinity;
  function warmNativeCheckout() {
    if (!warmEnabled || document.visibilityState === 'hidden' || performance.now() - warmedAt < 10000 ||
        !service.startsWith('https://') || !/(^|\.)ymq\.cool$/.test(new URL(service).hostname)) return;
    warmedAt = performance.now();
    document.querySelectorAll('link[data-bf-checkout-warm]').forEach(link => link.remove());
    for (const mode of warmModes) {
      const link = document.createElement('link');
      link.rel = 'preconnect'; link.href = service;
      if (mode) link.crossOrigin = mode;
      link.dataset.bfCheckoutWarm = '20261103'; document.head.append(link);
    }
    document.documentElement.dataset.bfCheckoutWarm = String(warmModes.length);
  }
  const checkoutIntent = '.ymq-ajax-cart-button,.ymq_c_btn,[name="checkout"]';
  const purchaseIntent = '#product-add-to-cart,.bf-compact-header__cart,' + checkoutIntent;
  if (warmEnabled) {
    for (const type of ['pointerdown', 'click']) document.addEventListener(type, event => {
      if (event.target.closest?.(purchaseIntent)) warmNativeCheckout();
    }, {capture:true, passive:true});
    for (const type of ['pointerover', 'focusin']) document.addEventListener(type, event => {
      if (event.target.closest?.(checkoutIntent)) warmNativeCheckout();
    }, {capture:true, passive:true});
    if (cartPage) warmNativeCheckout();
  }

  const snapshotSection = 'bf-native-cart-json';
  let bundledSnapshot = null, mutationGeneration = 0, prefilterInstalled = false;
  function installBundledRead() {
    const jq = typeof ymqJq === 'function' ? ymqJq : window.ymqJq;
    if (prefilterInstalled || typeof jq?.ajaxPrefilter !== 'function') return;
    prefilterInstalled = true;
    document.documentElement.dataset.bfPurchaseBundle = 'ready';
    jq.ajaxPrefilter((options, original) => {
      let url; try {url = new URL(options.url, location.href);} catch {return;}
      if (url.origin !== location.origin || String(options.type || 'GET').toUpperCase() !== 'POST' ||
          !/\/cart\/(?:add|change|update|clear)\.js$/.test(url.pathname)) return;
      const generation = ++mutationGeneration; bundledSnapshot = null;
      if (!productPage || !/\/cart\/add\.js$/.test(url.pathname) || !url.searchParams.has('_easygift_form_payload') ||
          !document.querySelector('.ymq-btn-progress')) return;
      const data = original.data;
      if (!data || Object.getPrototypeOf(data) !== Object.prototype || !Array.isArray(data.items) || !data.items.length ||
          Object.keys(data).some(k => !['items','sections','sections_url'].includes(k))) return;
      const sections = Array.isArray(data.sections) ? [...data.sections] : String(data.sections || '').split(',').filter(Boolean);
      if (!sections.includes(snapshotSection)) sections.push(snapshotSection);
      if (sections.length > 5) return;
      // Preserve every native item/property. Shopify renders the authoritative cart in the same successful add response.
      const request = {...data, sections:sections.join(','), sections_url:data.sections_url || '/cart'};
      document.documentElement.dataset.bfPurchaseBundle = 'requested';
      original.data = request; options.data = JSON.stringify(request);
      options.contentType = 'application/json'; options.processData = false;
      const priorFilter = options.dataFilter;
      options.dataFilter = function(raw, type) {
        const filtered = priorFilter ? priorFilter.call(this, raw, type) : raw;
        try {
          const html = JSON.parse(filtered).sections?.[snapshotSection];
          if (typeof html === 'string' && generation === mutationGeneration) {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const snapshot = JSON.parse(doc.querySelector('[data-bf-native-cart-json]')?.textContent || 'null');
            if (snapshot && Array.isArray(snapshot.items) && Number.isInteger(snapshot.item_count) &&
                typeof snapshot.total_price === 'number' && snapshot.items.every(item => item.key &&
                  Number.isInteger(item.quantity) && Array.isArray(item.options_with_values) &&
                  typeof item.product_title === 'string' && typeof item.original_price === 'number')) {
              bundledSnapshot = {cart:snapshot, generation, at:Date.now()};
              document.documentElement.dataset.bfPurchaseBundle = 'available';
            }
          }
        } catch { /* A missing/unavailable section must never retry a successful add. */ }
        return filtered;
      };
    });
  }
  installBundledRead();
  const originalFetch = window.fetch;
  window.fetch = function(input, options) {
    // Both native mini-cart rendering and checkout use this empty POST solely to read the cart.
    // The app already accepts GET /cart.js on its own fallback path. Always obtain a fresh response.
    if ((typeof input === 'string' || input instanceof URL) && options &&
        Object.keys(options).length === 1 && options.method === 'POST' &&
        document.querySelector('.ymq-btn-progress')) {
      const url = new URL(input, location.href);
      if (url.origin === location.origin && /\/cart\/update\.js$/.test(url.pathname) &&
          [...url.searchParams.keys()].every(key => key === 'timestamp')) {
        if (!url.search && bundledSnapshot?.generation === mutationGeneration && Date.now() - bundledSnapshot.at < 2000) {
          const snapshot = bundledSnapshot.cart; bundledSnapshot = null;
          document.documentElement.dataset.bfPurchaseBundle = 'used';
          const response = new Response(JSON.stringify(snapshot), {status:200, headers:{'Content-Type':'application/json'}});
          // Ymq recognises cart responses by URL before running its own refresh and linked-variant validation hooks.
          Object.defineProperty(response,'url',{value:url.href});
          return Promise.resolve(response);
        }
        url.pathname = url.pathname.replace(/cart\/update\.js$/, 'cart.js');
        return Reflect.apply(originalFetch, this, [url.href, {method:'GET', cache:'no-store'}]);
      }
    }
    return Reflect.apply(originalFetch, this, arguments);
  };

  const style = document.createElement('style');
  style.id = 'bf-purchase-fast-style';
  style.textContent = `
    [data-bf-purchase-fast] .ymq-cd-panel {font-family:Poppins,Arial,sans-serif;color:#172d4e;z-index:2147483000}
    [data-bf-purchase-fast] .ymq-cd-panel__cart-drawer {width:min(560px,100vw)!important;max-width:100vw}
    [data-bf-purchase-fast] .ymq-cd-panel__header,
    [data-bf-purchase-fast] .ymq-cd-panel__footer,
    [data-bf-purchase-fast] .ymq-cd-panel__container {width:100%!important;max-width:100vw;transition:none!important}
    [data-bf-purchase-fast] .ymq-cd-panel__header {background:#fff;color:#172d4e;border-bottom:1px solid #e6e9ed}
    [data-bf-purchase-fast] .ymq-cd-panel__close {display:grid;place-items:center;position:absolute;right:0;top:0;width:50px;height:50px;background:#fff!important;font-size:0!important;text-indent:0!important;transform:none!important}
    [data-bf-purchase-fast] .ymq-cd-panel__close:hover {background:#f4f6f9!important}
    [data-bf-purchase-fast] .ymq-cd-panel__close::before {content:'×'!important;position:static!important;display:block!important;font:32px/1 Arial,sans-serif!important;color:#172d4e!important;background:none!important;transform:none!important;width:auto!important;height:auto!important}
    [data-bf-purchase-fast] .ymq-cd-panel__close::after {display:none!important}
    [data-bf-purchase-fast] .ymq-cart-header-svg {display:none}
    [data-bf-purchase-fast] .bf-fast-cart-title {font-size:22px;font-weight:600;margin-right:12px}
    [data-bf-purchase-fast] .ymq-cart-item-count,
    [data-bf-purchase-fast] .ymq-cart-item-count-html {font-size:14px;font-weight:400}
    [data-bf-purchase-fast] .ymq-cd-panel__content {padding:20px;background:#fff}
    [data-bf-purchase-fast] .ymq-cart-item {padding-block:18px;border-bottom:1px solid #e6e9ed}
    [data-bf-purchase-fast] .ymq-cart-item-title {font-family:inherit;font-size:17px;font-weight:500;line-height:1.4;text-transform:capitalize}
    [data-bf-purchase-fast] .ymq-cart-item-properties {font-size:13px;line-height:1.5;color:#36475c}
    [data-bf-purchase-fast] .ymq-cart-item-price {font-weight:600;color:#172d4e}
    [data-bf-purchase-fast] .ymq-cd-panel__footer {background:#fff;border-top:1px solid #e6e9ed;box-shadow:0 -6px 20px #172d4e0c}
    [data-bf-purchase-fast] .ymq-ajax-cart-button {min-height:54px;padding:14px 16px;border-radius:10px;background:#172d4e!important;color:#fff!important;font-family:inherit;font-size:17px;font-weight:600;line-height:1.5}
    [data-bf-purchase-fast] .ymq-ajax-cart-button.ymq-btn-progress {opacity:.8;cursor:progress}
    [data-bf-purchase-fast] .ymq-ajax-view-cart {font-size:14px;color:#172d4e}
    [data-bf-purchase-fast] .ymq-cart-item-remove {color:#c35418;text-decoration:underline;cursor:pointer}
    [data-bf-purchase-fast] .ymq-cd-panel :focus-visible {outline:3px solid #ec8a4b;outline-offset:3px}
    @media(max-width:600px){[data-bf-purchase-fast] .ymq-cd-panel__content{padding:16px}[data-bf-purchase-fast] .ymq-cart-item-title{font-size:16px}}
  `;
  document.head.append(style);

  let wasOpen = false, returnFocus = null, scheduled = false;
  function decorate() {
    scheduled = false;
    installBundledRead();
    const root = document.querySelector('.ymq-cd-panel');
    if (!root) return;
    root.setAttribute('role', 'dialog'); root.setAttribute('aria-label', 'Your cart');
    root.querySelector('.ymq-cd-panel__close')?.setAttribute('aria-label','Close cart');
    const heading = root.querySelector('.ymq-cd-panel__header h1');
    const count = root.querySelector('.ymq-cart-item-count')?.textContent.trim();
    if (/^\d+$/.test(count || '')) {
      const cartLink = document.querySelector('.bf-compact-header__cart');
      const badge = cartLink?.querySelector('[data-cart-count]');
      if (badge && badge.textContent !== count) badge.textContent = count;
      if (badge) badge.hidden = Number(count) === 0;
      const label = `Cart ${count} ${Number(count) === 1 ? 'item' : 'items'}`;
      if (cartLink && cartLink.getAttribute('aria-label') !== label) cartLink.setAttribute('aria-label',label);
    }
    if (heading && !heading.querySelector('.bf-fast-cart-title')) {
      const title = document.createElement('span'); title.className = 'bf-fast-cart-title'; title.textContent = 'Your cart'; heading.prepend(title);
    }
    for (const element of root.querySelectorAll('.ymq-ajax-cart-button,.ymq-cart-item-remove,.ymq-cart-item-quantity-action')) {
      element.setAttribute('role','button'); element.tabIndex = 0;
      if (element.classList.contains('ymq-cart-item-quantity-action')) {
        element.setAttribute('aria-label',element.dataset.type === 'add' ? 'Increase quantity' : 'Decrease quantity');
      }
      element.setAttribute('aria-busy',String(element.classList.contains('ymq-btn-progress')));
    }
    for (const input of root.querySelectorAll('.ymq-cart-item-quantity-input')) input.setAttribute('aria-label','Quantity');
    // Retain an existing server cart note on first opening without replacing a new user edit.
    const note = root.querySelector('.ymq-cart-note');
    if (note && !note.dataset.bfNoteInitialised) {
      note.value = native?.cartInstance?.cartJson?.note || '';
      note.dataset.bfNoteInitialised = '1';
    }
    const open = root.classList.contains('ymq-cd-panel--is-visible');
    root.setAttribute('aria-modal', String(open));
    if (open && !wasOpen) {
      warmNativeCheckout();
      returnFocus = document.activeElement;
      root.querySelector('.ymq-cd-panel__close')?.focus({preventScroll:true});
    } else if (!open && wasOpen && root.contains(document.activeElement) && returnFocus?.isConnected) {
      returnFocus.focus({preventScroll:true});
    }
    wasOpen = open;
  }
  const observer = new MutationObserver(() => {
    if (!scheduled) {scheduled = true; requestAnimationFrame(decorate);}
  });
  observer.observe(document.body,{subtree:true,childList:true,attributes:true,attributeFilter:['class']});
  document.addEventListener('keydown', event => {
    const root = document.querySelector('.ymq-cd-panel--is-visible');
    if (!root) return;
    if (event.key === 'Escape') {event.preventDefault();root.querySelector('.ymq-cd-panel__close')?.click();return;}
    const target = event.target.closest?.('[role="button"]');
    if (target && root.contains(target) && ['Enter',' '].includes(event.key)) {
      event.preventDefault(); if(target.getAttribute('aria-busy') !== 'true')target.click();
    }
    if(event.key === 'Tab'){
      const controls=[...root.querySelectorAll('a[href],button,input,select,textarea,[tabindex="0"]')].filter(e=>!e.disabled&&e.getBoundingClientRect().height>0);
      const first=controls[0],last=controls.at(-1);
      if(event.shiftKey&&document.activeElement===first){event.preventDefault();last?.focus();}
      else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first?.focus();}
    }
  });
  decorate();
})();
